export default {
  carriers: [],
  carrierZhs: []
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/state.js